import React from 'react';
import styled from 'astroturf/react';

import routes from 'js/core_pre_webpack/routes';
import PremiumLock from 'js/premium/PremiumLock';
import trackClick from 'js/utils/trackClick';

const CellLink = styled.a`
  @import 'stylesheets/design_system/font';
  @include body__medium;

  display: flex;
  flex: 0 0 auto;
  align-items: center;
  column-gap: 8px;
  height: 100%;
  padding: 0 20px;
  background: var(--button-primary-fill, #0645b1);
  color: var(--text-white, #ffffff);
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    background: var(--button-primary-fill-hover, #0c3b8d);
  }

  &:hover,
  &:active,
  &:visited {
    color: var(--text-white, #ffffff);
    text-decoration: none;
  }
`;

export type PremiumCtaCellProps = {
  isPremium: boolean;
  trialPricingCopy?: string | null;
  bucket: string;
};

const PremiumCtaCell = ({
  isPremium,
  trialPricingCopy,
  bucket,
}: PremiumCtaCellProps) => {
  if (isPremium || trialPricingCopy == null || trialPricingCopy === '') {
    return null;
  }

  return (
    <CellLink
      href={routes.upgrade_url({
        feature: 'default',
        from_navbar: true,
        trigger: 'nav_impact_bar',
      })}
      onClick={() =>
        trackClick({ source: 'nav-bar--impact-premium-cta', bucket })
      }
      data-testid="premium-cta-cell"
    >
      <PremiumLock circleColor="white" lockColor="blue" width={20} />
      {trialPricingCopy}
    </CellLink>
  );
};

export default PremiumCtaCell;
